import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {MobileMenuHeaderDefaultBox} from "./mobile-menu-header.default.box";
import {MobileMenuHeaderSiBox} from "./mobile-menu-header.si.box";

export const MobileMenuHeaderBox = styledByTheme(MobileMenuHeaderDefaultBox).forSI(MobileMenuHeaderSiBox).apply();